module.exports = __webpack_public_path__ + "assets/img/nedbank-cup-final.jpg?1df530fe80247e721c3a22748f3b55a1";